<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-charging-pole`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 2a1 1 0 011 1v5h8V3a1 1 0 011-1h2a1 1 0 011 1v5h5a2 2 0 012 2v32h2a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2a1 1 0 011-1h2V10a2 2 0 012-2h5V3a1 1 0 011-1h2zm16 10H13v30h22V12zm-8.444 6.796a.795.795 0 00-1.377-.539l-7.97 8.7a.798.798 0 00.436 1.32l4.143.79v6.137a.794.794 0 001.403.509l7.626-9.213a.798.798 0 00-.49-1.295l-3.771-.584v-5.825z"/></svg>
</template>
<script>

export default {
  name: 'IconChargingPole',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
